<template>
	<div>
		<el-row style="margin-top: 75px;">
			<div style="font-size:20px;float:left;margin:-40px 0 0 40px;font-weight:600">
				员工入职-详情</div>
			<el-button
				style="float: right; height: 40px; margin-top: -40px; margin-right: 40px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
				@click="Return">返回</el-button>
		</el-row>

		<div style="margin:0px 40px 0 40px; height: 800px; background-color: #FFFFFF;">

			<div style="height: 30px;"></div>
			<div
				style="border-left: 3px #006E48 solid; margin-left: 5%; border-bottom: 1px #f8f8f8 solid; margin-right: 5%;">
				<span style="font-size:20px;font-weight:700">基础信息</span>
			</div>

			<el-row style="text-align: center; margin-top: 40px;">
				<el-col :span="6">
					<lable class="label">姓名：</lable>
					<span>{{ruleForm.staff.staff_name}}</span>
				</el-col>
				<el-col :span="6">
					<lable class="label">性别：</lable>
					<span>{{ruleForm.staff.staff_gender}}</span>
				</el-col>
				<el-col :span="6">
					<lable class="label">身份证号码：</lable>
					<span>{{ruleForm.staff.staff_card}}</span>
				</el-col>
				<el-col :span="6">
					<lable class="label">手机号：</lable>
					<span>{{ruleForm.staff.staff_telephone}}</span>
				</el-col>
			</el-row>
			<el-row style="text-align: center; margin-top: 40px;">
				<el-col :span="6">
					<lable class="label">本人照片：</lable>
					<el-image style="width: 100px; height: 100px" :src="ruleForm.staff.staff_photo">
					</el-image>
				</el-col>
				<el-col :span="6">
					<lable class="label">身份证原件照片：</lable>
					<el-image style="width: 100px; height: 100px" :src="ruleForm.staff.card_photo">
					</el-image>
				</el-col>
				<el-col :span="6">
					<lable class="label">银行卡号：</lable>
					<span>{{ruleForm.staff.bank_no}}</span>
				</el-col>
				<el-col :span="6">
					<lable class="label">开户行：</lable>
					<span>{{ruleForm.staff.bankName}}</span>
				</el-col>
			</el-row>
			<el-row style="text-align: center; margin-top: 40px;">
				<el-col :span="6">
					<lable class="label">银行卡照片：</lable>
					<el-image style="width: 100px; height: 100px" :src="ruleForm.staff.bank_photo">
					</el-image>
				</el-col>
			</el-row>

			<div
				style="border-left: 3px #006E48 solid; margin-top: 60px; margin-left: 5%; border-bottom: 1px #f8f8f8 solid; margin-right: 5%;">
				<span style="font-size:20px;font-weight:700">入职信息</span>
			</div>
			<el-row style="text-align: center; margin-top: 40px;">
				<el-col :span="6">
					<lable class="label">组织架构：</lable>
					<span>{{ruleForm.staff.range}}</span>
				</el-col>
				<el-col :span="6">
					<lable class="label">城市：</lable>
					<span>{{ruleForm.staff.city_id}}</span>
				</el-col>
				<el-col :span="6">
					<lable class="label">职位：</lable>
					<span>{{ruleForm.post_name}}</span>
				</el-col>
				<el-col :span="6">
					<lable class="label">入职薪酬：</lable>
					<span>{{ruleForm.induction_salary}}</span>
				</el-col>
			</el-row>
			<el-row style="text-align: center; margin-top: 40px;">
				<el-col :span="6">
					<lable class="label">入职日期：</lable>
					<span>{{ruleForm.induction_time}}</span>
				</el-col>
				<el-col :span="6">
					<lable class="label">是否有试用期：</lable>
					<span>{{ruleForm.is_trial == '1' ? '是' : '否'}}</span>
				</el-col>
				<el-col :span="6">
					<lable class="label">试用期时间：</lable>
					<span>{{ruleForm.trial_start + "至" + ruleForm.trial_end}}</span>
				</el-col>
				<el-col :span="6">
					<lable class="label">试用期薪资：</lable>
					<span>{{ruleForm.induction_salary}}</span>
				</el-col>
			</el-row>
			<el-row style="text-align: center; margin-top: 40px;">
				<el-col :span="6">
					<lable class="label"> 入职添加日期：</lable>
					<span>{{ruleForm.induction_date}}</span>
				</el-col>
				<el-col :span="3">
					<lable class="label">签约合同上传：</lable>
				</el-col>
				<el-col :span="15">
					<el-row>
						<el-col :span="12" v-for="(item, index) in fileList" :key="index">
							<div
								style=" width: 90%; border: 1px solid #e9e9e9; border-radius: 5px; padding: 0 10px; height: 100px;">
								<el-row>
									<el-col :span="6" style="margin: 13px 0px;">
										<img src="../../../assets/icon/文件类型-附件@2x.png" width="65px" height="73px" />
									</el-col>
									<el-col :span="12" style="margin: 30px 0px;">
										<span>{{item.name}}</span>
										<br />
									</el-col>
									<el-col :span="6" style="margin: 36px 0px;">
										<el-button size="mini"
											style="background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;">
											下载附件</el-button>
									</el-col>
								</el-row>
							</div>
						</el-col>
					</el-row>
				</el-col>
			</el-row>

		</div>
	</div>
</template>

<script>
	export default {
		props: ["ruleForm"],
		data() {
			return {
				fileList: [],
			};
		},
		methods: {
			Return() {
				this.$emit("return");
			},
		},
		created() {},
		watch: {
			"ruleForm.contract_url"(newValue) {
				newValue.split(";").forEach((item, index) => {
					if (item != null && item != '') {
						var file = item.split("/");
						this.fileList.push({
							name: file[file.length - 1],
							url: item
						})
					}
				})
			}
		}
	};
</script>

<style scoped="scoped">
	.label {
		color: #b3b3b3;
	}
</style>



// WEBPACK FOOTER //
// Ygrz_edit.vue?1cfb8a24